// App Bridge (session-token) glue — only used on /shop-app admin routes, only inside the Shopify admin iframe.
// The session token is fetched fresh for every request and never stored.
const KEY = process.env.REACT_APP_SHOPIFY_API_KEY;
const APP_BRIDGE_SRC = "https://cdn.shopify.com/shopifycloud/app-bridge.js";

export function isEmbedded() {
  try {
    return window.top !== window.self;
  } catch {
    return true; // cross-origin access throws → we are framed (embedded)
  }
}

let _loading = null;

export function ensureAppBridge() {
  if (!isEmbedded() || !KEY) return Promise.resolve(false);
  if (window.shopify?.idToken) return Promise.resolve(true);
  if (_loading) return _loading;
  _loading = new Promise((resolve) => {
    // The <meta> must exist before app-bridge.js runs, so it can read the api key.
    if (!document.querySelector('meta[name="shopify-api-key"]')) {
      const meta = document.createElement("meta");
      meta.name = "shopify-api-key";
      meta.content = KEY;
      document.head.appendChild(meta);
    }
    const existing = document.querySelector(`script[src="${APP_BRIDGE_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(!!window.shopify?.idToken));
      if (window.shopify?.idToken) resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = APP_BRIDGE_SRC;
    script.onload = () => resolve(!!window.shopify?.idToken);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
  return _loading;
}

export async function adminToken() {
  const ok = await ensureAppBridge();
  if (!ok || !window.shopify?.idToken) throw new Error("not-embedded");
  return window.shopify.idToken();
}
